import React from 'react';
import { CardBody } from "reactstrap";
import './ReferralAnalytics.css';

const ReferralCardBody = ({ iconType }) => {
    const getIconClass = () => {
        switch(iconType) {
            case 'download':
                return 'fa fa-download';
            case 'share':
                return 'fa fa-share-alt';
            case 'percentage':
                return 'fa fa-percent';
            default:
                return 'fa fa-chart-bar';
        }
    };

    const getAnimationClass = () => {
        switch(iconType) {
            case 'download':
                return 'animate-bg-primary';
            case 'share':
                return 'animate-bg-success';
            case 'percentage':
                return 'animate-bg-warning';
            default:
                return 'animate-bg-primary';
        }
    };

    return (
        <CardBody className="card-body pt-0">
            <div className="right-side icon-right-info">
                <i className={getIconClass()}></i>
                <div className="shap-block">
                    <div className={`rounded-shap ${getAnimationClass()}`}>
                        <i className='circle3'></i>
                        <i className='circle4'></i>
                    </div>
                </div>
            </div>
        </CardBody>
    );
};

export default ReferralCardBody;